import { Chip, chipClasses, styled, Tooltip } from '@mui/material';
import i18n from '../../libs/language';

const StyledChip = styled(Chip)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FFC107',
  color: theme.palette.getContrastText('#FFC107'),
  width: 40,
  height: 20,
  fontWeight: 800,
  fontSize: '0.6rem',
  borderRadius: '4px',
  textTransform: 'uppercase',
  cursor: 'default',
  border: `1px dotted ${theme.palette.getContrastText('#FFC107')}`,
  [`& .${chipClasses.label}`]: {
    padding: 0,
    margin: 0,
  },
}));

export function BetaBadge() {
  const title = i18n.t('app.beta_badge');
  return (
    <Tooltip title={title} arrow disableInteractive>
      <StyledChip label="BETA" />
    </Tooltip>
  );
}
